function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
var t = e(require("short-uuid")),
  r = e(require("crypto-js")),
  i = new Date(+new Date() + 864e5).toISOString(),
  n = i.split("-").join("").split(":").join("").split(".").join(""),
  o = i.split("T")[0].split("-").join(""),
  a = function a() {};
a.getPolicy = function (e) {
  return new Buffer(JSON.stringify({
    expiration: i,
    conditions: [{
      acl: "public-read"
    }, {
      bucket: e.bucketName
    }, ["starts-with", "$key", e.dirName ? e.dirName + "/" : ""], ["starts-with", "$Content-Type", ""], ["starts-with", "$x-amz-meta-tag", ""], {
      "x-amz-algorithm": "AWS4-HMAC-SHA256"
    }, {
      "x-amz-credential": e.accessKeyId + "/" + o + "/" + e.region + "/s3/aws4_request"
    }, {
      "x-amz-date": n
    }, {
      "x-amz-meta-uuid": "14365123651274"
    }, {
      "x-amz-server-side-encryption": "AES256"
    }]
  })).toString("base64").replace(/\n|\r/, "");
};
var c = function c() {};
c.getSignature = function (e, t, i) {
  var n, o, a, c, s, u;
  return r.HmacSHA256(i, (n = e.secretAccessKey, o = t, a = e.region, c = r.HmacSHA256(o, "AWS4" + n), s = r.HmacSHA256(a, c), u = r.HmacSHA256("s3", s), r.HmacSHA256("aws4_request", u))).toString(r.enc.Hex);
};
var s = function s(e) {
  this.config = e;
};
s.prototype.uploadFile = function (e, t) {
  try {
    var r = this;
    !function (e, t) {
      if (null === e.bucketName || "" === e.bucketName) throw new Error("Your bucketName cannot be empty ");
      if (null === e.region || "" === e.region) throw new Error("Must provide a valide region in order to use your bucket");
      if (null === e.accessKeyId || "" === e.accessKeyId) throw new Error("Must provide accessKeyId");
      if (null === e.secretAccessKey || "" === e.secretAccessKey) throw new Error("Must provide secretAccessKey");
      if (!t) throw new Error("File cannot be empty");
    }(r.config, e);
    var i = new FormData(),
      s = r.getFileNameWithExtension(e, t),
      u = (r.config.dirName ? r.config.dirName + "/" : "") + s,
      m = (p = r.config).s3Url && "" !== p.s3Url ? p.s3Url : function (e) {
        var t = e.bucketName,
          r = e.region,
          i = r.split("-")[0];
        switch (i) {
          case "cn":
            return "https://" + t + ".s3." + r + ".amazonaws.com." + i;
          default:
            return "https://" + t + ".s3-" + r + ".amazonaws.com";
        }
      }(p);
    return i.append("key", u), i.append("acl", "public-read"), i.append("Content-Type", e.type), i.append("x-amz-meta-uuid", "14365123651274"), i.append("x-amz-server-side-encryption", "AES256"), i.append("X-Amz-Credential", r.config.accessKeyId + "/" + o + "/" + r.config.region + "/s3/aws4_request"), i.append("X-Amz-Algorithm", "AWS4-HMAC-SHA256"), i.append("X-Amz-Date", n), i.append("x-amz-meta-tag", ""), i.append("Policy", a.getPolicy(r.config)), i.append("X-Amz-Signature", c.getSignature(r.config, o, a.getPolicy(r.config))), i.append("file", e), Promise.resolve(fetch(m, {
      method: "post",
      body: i
    })).then(function (e) {
      return e.ok ? Promise.resolve({
        bucket: r.config.bucketName,
        key: (r.config.dirName ? r.config.dirName + "/" : "") + s,
        location: m + "/" + (r.config.dirName ? r.config.dirName + "/" : "") + s,
        status: e.status
      }) : Promise.reject(e);
    });
  } catch (e) {
    return Promise.reject(e);
  }
  var p;
}, s.prototype.deleteFile = function (e) {
  try {
    return Promise.resolve(fetch("https://" + this.config.bucketName + ".s3" + (this.config.region ? "-" + this.config.region : "") + ".amazonaws.com/" + (this.config.dirName ? this.config.dirName + "/" : "") + e, {
      method: "delete"
    })).then(function (t) {
      return t.ok ? Promise.resolve({
        ok: t.ok,
        status: t.status,
        message: "File Deleted",
        fileName: e
      }) : Promise.reject(t);
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, s.prototype.getFileNameWithExtension = function (e, r) {
  return r && r.includes(".") ? r : (r || t.generate()) + "." + e.type.split("/")[1];
}, module.exports = s;